module.exports = __webpack_public_path__ + "img/bj_04.8f49988e.jpg";